import styled from "styled-components";

import { Button } from "../Button";

export const StyledGlobalAddButton = styled(Button)`
  svg {
    fill: var(--color-theme-100);
  }
  &:hover svg {
    transform: rotate(90deg);
    transition: ease 0.3s;
  }
`;

StyledGlobalAddButton.displayName = "StyledGlobalAddButton";
